module.exports = __webpack_public_path__ + "fa-solid-900.56cf83dc307672a2d5d0.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/webfonts/fa-solid-900.ttf
// module id = ../../../../../src/assets/fonts/webfonts/fa-solid-900.ttf
// module chunks = styles